import { Newrelic } from '@wix/wix-bootstrap-ng/typed';
import Sentry from '@sentry/browser';

export type ErrorToReport = Error | { message: string };
export type CustomAttributes = { [key: string]: string | number | boolean };

export interface ErrorReporter {
  reportError: (error: ErrorToReport, customAttributes?: CustomAttributes) => void;
}

export class NewRelicErrorReporter implements ErrorReporter {
  constructor(private readonly newrelic: Newrelic) {}

  reportError(error: ErrorToReport, customAttributes?: CustomAttributes) {
    this.newrelic.noticeError(error as Error, customAttributes);
  }
}

export class SentryErrorReporter implements ErrorReporter {
  constructor(private readonly sentry: typeof Sentry) {}

  reportError(error: ErrorToReport, customAttributes?: CustomAttributes) {
    this.sentry.withScope((scope) => {
      Object.entries(customAttributes || {}).forEach(([key, value]) => scope.setExtra(key, value));
      this.sentry.captureException(error);
    });
  }
}

export class ConsoleErrorReporter implements ErrorReporter {
  reportError(error: ErrorToReport, customAttributes?: CustomAttributes) {
    console.error(error, customAttributes);
  }
}
